import { Injectable } from '@angular/core';
import { ListService } from 'bookraw/shared/services/list.service';
import { SchoolClass } from 'bookraw/shared/models/school-class.model';

@Injectable()
export class SchoolClassesService extends ListService<SchoolClass> {

  url: string = '/api/admin/schoolClasses';
}
